export default {
    namespaced: true,
    state: {
        estado:{
            mensaje: '',
            ocupado: false
        }
    },
    mutations: {
        SET_ESTADO(state, estado){
            state.estado = estado;
            state.estado.ocupado = state.estado.ocupado == 1? true : false;
        },
    },
    actions: {
        setEstado({commit}, estado){
            commit('SET_ESTADO', estado);
        },
    }
}